import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import DigitizeImg from "../../../images/location_new/fold5/custom-laptop.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Digitize(props) {
  return (
    <div className="digitize_sec p-100" style={{ backgroundColor: "#214092" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Build a Next-Gen Product with Our Custom Software Development in
              UK
            </h2>
            <p>
              TekRevol always remains a step ahead of the competition due to its
              innovation-driven approach towards custom software development
              services. We consider every possibility to build something new as
              a product apart from fulfilling the client's requirements. That’s
              how we develop software that optimizes the working process while
              streamlining the operations based on rich-feature functionalities.
            </p>
            <p>
              Meanwhile, the structure and the overall interface of the software
              application are enhanced with our premium designing practices. So,
              you can rely on our software development company UK for every
              phase of the creation of your product.
            </p>
            <Link
              style={{
                backgroundColor: "#fff",
                color: "#214092",
                border: "1px solid #214092",
              }}
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="digitize_img">
            <LazyLoadImage
              src={DigitizeImg}
              effect="blur"
              alt="custom-software-development-company-london"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Digitize;
